export default {
    footer: {
        termsLink: 'Terms of use',
        legalLink: 'Legal information',
        message: '©2020 Cleandataset. All Rights Reserved.',
    },
};
